import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useChangeLanguage = () => {
  const { i18n } = useTranslation();
  const [isChangingLanguage, setIsChangingLanguage] = useState(false);

  const changeLanguage = useCallback(() => {
    if (!i18n || !i18n.language || isChangingLanguage) {
      console.error(
        'i18n is not properly initialized, language is undefined, or language change is in progress',
      );
      return;
    }

    setIsChangingLanguage(true);

    const currentLanguage = i18n.language;
    const newLanguage = currentLanguage === 'en' ? 'hu' : 'en';
    i18n
      .changeLanguage(newLanguage)
      .then(() => setIsChangingLanguage(false))
      .catch((error) => {
        console.error('Failed to change language:', error);
        setIsChangingLanguage(false);
      });
  }, [i18n, isChangingLanguage]);

  return changeLanguage;
};

export default useChangeLanguage;
